import React from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components/macro';
import { Button as AntdButton } from 'antd';

const getStyleFromType = type => {
  switch (type) {
    case 'cta':
      return css`
        padding: 8px 32px !important;
        background-image: linear-gradient(to right, ${props => props.theme.color.secondary}, ${props => props.theme.color.gradientEndOfSecondary}) !important;
        color: ${props => props.theme.color.darkGrey} !important;
      `;
    case 'primary':
      return css`
        padding: 2% 4% !important;
        height: 40px !important;
        width: 100% !important;
        background-color: ${props => props.theme.color.primary} !important;
        color: ${props => props.theme.color.white} !important;
      `;
    case 'secondary':
      return css`
        padding: 2% 4% !important;
        height: 40px !important;
        width: 100% !important;
        background-color: transparent !important;
        color: ${props => props.theme.color.primary} !important;
        box-shadow: inset 0 0 0 1px ${props => props.theme.color.primary} !important;
      `;
    case 'search':
      return css`
        background-color: ${props => props.theme.color.secondary} !important;
        width: 64px !important;
        height: 40px !important;
        color: white !important;
        border-top-left-radius: 0 !important;
        border-bottom-left-radius: 0 !important;

        @media (min-width: 768px) {
          height: 56px !important;
        }
      `;
    case 'landing-search':
      return css`
        background-color: ${props => props.theme.color.secondary} !important;
        width: 64px !important;
        height: 40px !important;
        color: ${props => props.theme.color.black} !important;
        border-top-left-radius: 0 !important;
        border-bottom-left-radius: 0 !important;
      `;
    case 'host-search':
      return css`
        background-color: ${props => props.theme.color.secondary} !important;
        width: 40px !important;
        height: 40px !important;
        color: ${props => props.theme.color.darkGrey} !important;
        border-top-left-radius: 0 !important;
        border-bottom-left-radius: 0 !important;
        padding-left: 10px;
      `;
    default:
      return null;
  }
};

const StyledAntdButton = styled(AntdButton)`
  border-radius: ${props => (props.round ? '24px' : '12px')} !important;
  :focus {
    outline: 0 !important;
  }

  :active {
    outline: 0 !important;
  }
  cursor: pointer !important;
  border-style: none !important;
  ${props => getStyleFromType(props.type)}
  width: ${props => (props.fullWidth ? '100%' : 'auto')};
`;

const Button = ({ toUrl, prevUrl, ...props }) => {
  if (toUrl) {
    if (toUrl.startsWith('http')) {
      return (
        <a href={toUrl}>
          <StyledAntdButton {...props} />
        </a>
      );
    } else {
      const nextPath = prevUrl ? { pathname: toUrl, state: { prevPath: prevUrl } } : toUrl;
      return (
        <Link to={nextPath}>
          <StyledAntdButton {...props} />
        </Link>
      );
    }
  } else {
    return <StyledAntdButton {...props} />;
  }
};

Button.defaultProps = {
  round: '',
  toUrl: '',
  prevUrl: ''
};

export default Button;
